(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientTypeDeleteController',PatientTypeDeleteController);

    PatientTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'PatientType'];

    function PatientTypeDeleteController($uibModalInstance, entity, PatientType) {
        var vm = this;

        vm.patientType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PatientType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
